/*	
	Присваиваем конкретному модулю нулевой вес
*/

import { AppDispatch, RootState } from "../../../../../../shared/store/store";
import { setNullWeightForModule } from "../../../../../../shared/store/slices/app.slice";
import { getModulesFromStorage } from "./get-modules-from-storage";

const matchesKey = (moduleName: string | undefined, key: string) => {
	if (!moduleName) return false;
	return (
		moduleName === key ||
		moduleName.endsWith(`_${key}`) ||
		moduleName.includes(key)
	);
};

export const hideModuleThunk =
	(moduleKey: string) =>
	async (
		dispatch: AppDispatch,
		getState: () => RootState,
	): Promise<boolean> => {
		if (typeof window === "undefined") return false;
		try {
			let modules: any[] | null = getModulesFromStorage();

			if (!modules) {
				const state = getState();
				modules = state?.app?.modulesConfig ? [...state.app.modulesConfig] : [];
			}

			let changed = false;
			for (const m of modules) {
				const name = m.moduleName ?? m.module_name;
				if (matchesKey(name, moduleKey)) {
					m.moduleWeight = 0;
					if (Object.prototype.hasOwnProperty.call(m, "module_weight")) {
						m.module_weight = 0;
					}
					changed = true;
				}
			}

			if (changed) {
				localStorage.setItem("modulesConfig", JSON.stringify(modules));
				dispatch(setNullWeightForModule(moduleKey));
			}

			return changed;
		} catch (err) {
			console.warn("hideModuleThunk failed", err);
			return false;
		}
	};

export const hideModule = (moduleKey: string): boolean => {
	try {
		if (typeof window === "undefined") return false;
		const raw = localStorage.getItem("modulesConfig");
		let modules: any[] | null = null;
		if (raw) {
			const parsed = JSON.parse(raw);
			if (Array.isArray(parsed)) modules = parsed;
		}
		if (!modules) return false;
		let changed = false;
		for (const m of modules) {
			const name = m.moduleName ?? m.module_name;
			if (matchesKey(name, moduleKey)) {
				m.moduleWeight = 0;
				if (Object.prototype.hasOwnProperty.call(m, "module_weight")) {
					m.module_weight = 0;
				}
				changed = true;
			}
		}
		if (changed) {
			localStorage.setItem("modulesConfig", JSON.stringify(modules));
			try {
				const { store } = require("../../../../../../shared/store/store");
				const {
					setNullWeightForModule,
				} = require("../../../../../../shared/store/slices/app.slice");
				store.dispatch(setNullWeightForModule(moduleKey));
			} catch {}
		}
		return changed;
	} catch (err) {
		console.warn("hideModule failed", err);
		return false;
	}
};
